/**
 * Predictive search voor kennisbank (REST) + tonen/verbergen suggestielijst.
 */
function dkjEscapeHtml(text) {
    const d = document.createElement('div');
    d.textContent = text;
    return d.innerHTML;
}

function dkjEscapeAttr(text) {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;');
}

function dkjHighlightMatch(title, query) {
    const q = query.trim();
    if (!q) {
        return dkjEscapeHtml(title);
    }
    const lower = title.toLowerCase();
    const idx = lower.indexOf(q.toLowerCase());
    if (idx === -1) {
        return dkjEscapeHtml(title);
    }
    const before = title.slice(0, idx);
    const match = title.slice(idx, idx + q.length);
    const after = title.slice(idx + q.length);
    return `${dkjEscapeHtml(before)}<strong>${dkjEscapeHtml(match)}</strong>${dkjEscapeHtml(after)}`;
}

document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('.js-auto-suggest');
    if (!inputs.length) {
        return;
    }

    const restBase =
        typeof dkjKennisbankSearch !== 'undefined' && dkjKennisbankSearch.restUrl
            ? dkjKennisbankSearch.restUrl
            : '';

    const debouncers = new WeakMap();

    inputs.forEach((searchInput) => {
        const wrap = searchInput.closest('.position-relative');
        const autoSuggestContainer = wrap
            ? wrap.querySelector('.search-auto-suggest')
            : null;

        if (!autoSuggestContainer) {
            return;
        }

        const show = () => {
            autoSuggestContainer.classList.add('show');
            autoSuggestContainer.removeAttribute('hidden');
            autoSuggestContainer.classList.remove('opacity-0');
        };

        const hide = () => {
            autoSuggestContainer.classList.remove('show');
            autoSuggestContainer.setAttribute('hidden', '');
            autoSuggestContainer.classList.add('opacity-0');
        };

        const fetchSuggest = (q) => {
            if (!restBase || q.length < 2) {
                autoSuggestContainer.innerHTML = '';
                hide();
                return;
            }

            const url = new URL(restBase, window.location.origin);
            url.searchParams.set('search', q);

            fetch(url.toString(), {
                method: 'GET',
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
            })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return res.json();
                })
                .then((items) => {
                    if (!Array.isArray(items) || items.length === 0) {
                        autoSuggestContainer.innerHTML = '';
                        hide();
                        return;
                    }

                    autoSuggestContainer.innerHTML = items
                        .map((item) => {
                            const title = item.title || '';
                            const href = item.url || '#';
                            const label = dkjHighlightMatch(title, q);
                            return `<a href="${dkjEscapeAttr(href)}" class="search-auto-suggest__item">${label}</a>`;
                        })
                        .join('');

                    show();
                })
                .catch(() => {
                    autoSuggestContainer.innerHTML = '';
                    hide();
                });
        };

        const scheduleFetch = (q) => {
            const prev = debouncers.get(searchInput);
            if (prev) {
                clearTimeout(prev);
            }
            const t = window.setTimeout(() => fetchSuggest(q), 280);
            debouncers.set(searchInput, t);
        };

        searchInput.addEventListener('input', () => {
            const q = searchInput.value.trim();
            if (q.length < 2) {
                autoSuggestContainer.innerHTML = '';
                hide();
                return;
            }
            scheduleFetch(q);
        });

        searchInput.addEventListener('focus', () => {
            const q = searchInput.value.trim();
            if (q.length >= 2 && autoSuggestContainer.innerHTML.trim() !== '') {
                show();
            }
        });

        document.addEventListener('click', (event) => {
            if (
                !searchInput.contains(event.target) &&
                !autoSuggestContainer.contains(event.target)
            ) {
                hide();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                hide();
            }
        });
    });
});
